import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isVisible", "isLoading", "type", "title", "children", "onClose"];
import React from 'react';
import styled, { css } from 'styled-components';
import { pxToRem, hasReactChildren } from 'utils/ui';
import { spacing } from 'styles/globals';
import ThemeSection from 'components/ThemeSection';
import Button from 'components/Button';
import { alertTypeMap } from 'components/Alert';
import { SpinnerDot } from 'components/icons';
var Wrapper = styled.div.withConfig({
  displayName: "AlertBox__Wrapper",
  componentId: "sc-13f9pyu-0"
})(["position:relative;max-width:", ";padding:", ";padding-right:", ";color:", ";background-color:", ";box-shadow:0 0 ", " rgba(0,0,0,0.25);visibility:hidden;opacity:0;transition:visibility 0s linear 0.35s,opacity 0.35s ease-in;", " & + &{margin-top:", ";}"], pxToRem(320), spacing.s, spacing.xl, function (p) {
  return p.theme.text;
}, function (p) {
  return p.theme.background;
}, spacing.s, function (p) {
  return p.isVisible && css(["visibility:visible;opacity:1;transition-delay:0s;transition-timing-function:ease-out;"]);
}, spacing.m);
var Title = styled.h3.withConfig({
  displayName: "AlertBox__Title",
  componentId: "sc-13f9pyu-1"
})(["display:block;word-wrap:break-word;font-weight:600;line-height:1;text-transform:uppercase;"]);
var Message = styled.p.withConfig({
  displayName: "AlertBox__Message",
  componentId: "sc-13f9pyu-2"
})(["line-height:1.1;word-wrap:break-word;margin-top:", ";"], spacing.xxs);
var AlertBox = function AlertBox(_ref) {
  var _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
    isLoading = _ref.isLoading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'fail' : _ref$type,
    title = _ref.title,
    children = _ref.children,
    onClose = _ref.onClose,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var hasChildren = hasReactChildren(children);
  return /*#__PURE__*/React.createElement(ThemeSection, {
    name: alertTypeMap[type] || type
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    isVisible: isVisible
  }, otherProps), /*#__PURE__*/React.createElement(Title, {
    id: "alert_box_title"
  }, title, isLoading && /*#__PURE__*/React.createElement(SpinnerDot, {
    vAlign: true,
    ml: "xs"
  })), hasChildren && /*#__PURE__*/React.createElement(Message, {
    id: "alert_box_text"
  }, children), /*#__PURE__*/React.createElement(Button, {
    position: "absolute",
    right: "xxs",
    top: 6,
    size: "medium",
    icon: "x",
    variant: "transparent",
    onClick: onClose
  })));
};
export default AlertBox;